<template>
  <ul class="nav nav-mobile-menu">
    <li>
      <drop-down>
        <a slot="title" class="dropdown-toggle" data-toggle="dropdown">
          <i class="material-icons">person</i>
          <div class="user-names">
            <span class="ellipsis">{{ profileNameOrg }}</span>
            <span class="position">({{ profileName }})</span>
          </div>
        </a>
        <ul class="dropdown-menu dropdown-menu-right">
          <li>
            <router-link @click.native="toggleSidebar" :to="{ name: 'UserSettings' }">Настройки</router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Logout' }">Выйти</router-link>
          </li>
        </ul>
      </drop-down>
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      search: null,
      selectedEmployee: null
    };
  },
  props: {
    profileName: {
      type: String,
      default: null
    },
    profileNameOrg: {
      type: String,
      default: null
    }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    }
  }
};
</script>
<style scoped lang="scss">
.user-names {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
